export default "__VITE_ASSET__Bxqo3LAf__"